import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBackOfficeListRoles: build.query<
      GetBackOfficeListRolesApiResponse,
      GetBackOfficeListRolesApiArg
    >({
      query: () => ({ url: `/v1/bo/roles` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type GetBackOfficeListRolesApiResponse =
  /** status 200 OK */ EntityRole[];
export type GetBackOfficeListRolesApiArg = void;
export type EntityRole =
  | "rs-user"
  | "rs-admin"
  | "rs-system-admin"
  | "rs-tester";
export const { useGetBackOfficeListRolesQuery } = injectedRtkApi;
